import React, { useEffect, useState, Fragment, useRef } from "react";
import { TableContent } from '../../../Common/Table/tableContent';
import { LoadingMaterialTable } from "../../../../Common/table";

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.data;
        const contentRowNames = this.props.rowNames;
        const bagTotal = this.props.bagTotal;

        function totalBagCount(data){
            var total = 0;
            if(data!=null || data == undefined){
                data.forEach(element => {
                    total += parseFloat(element.bagCount)  
                  });
                return total;
            }
            return 0;
        }

        return (
            <div>
                <h3><center><u>Gross Quantity-Wise Bag Count Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Route: </b> {searchData[0].collectionPointID}</div>
                    <div className="col"><b>FromDate: </b> {searchData[0].fromDate}</div>
                    <div className="col"><b>ToDate: </b> {searchData[0].toDate}</div>

                </div>


                <div>
                    <table className="table table-bordered pb-3">
                        <thead>
                            <tr>
                                <th>Gross Quantity</th>
                                <th>Bag Count</th>
                                <th>Percentage(%)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <TableContent
                                data={data}
                                contentRowNames={contentRowNames}
                                hasEdit={false}
                            />

                        </tbody>

                    </table>
                </div>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Total Bag Count :  </b> {bagTotal}</div>

                </div>
            </div>
        );
    }
}


